function productControlsQtyDetect() {
	const productControlsContainer = document.querySelector(
		".product-screens__controls"
	);
	if (productControlsContainer) {
		const qty = productControlsContainer.childElementCount;
		// productIconsContainer.style.setProperty("--icon-qty", `${qty}`);
		if (qty > 4 || qty < 3) {
			productControlsContainer.classList.add("visually-hidden");
		}
		productControlsContainer.dataset.itemsQty = qty;
	}
}
